import { StatisticsConfig } from "../../hooks/reporting/statistics/useStatistics";

export const fakeMachineData = [
  { label: "M1", value: "M1" },
  { label: "M2", value: "M2" },
  { label: "M3", value: "M3" },
];

export const fakeDesignData = [
  { label: "D1", value: "D1" },
  { label: "D2", value: "D2" },
  { label: "D3", value: "D3" },
];

export const fakeDataConfig: StatisticsConfig = {
  grouped: false,
  amount: 10,
  fakeData: true,
};

export function getTimeDifference(fromDate: string): string {
  const from = new Date(fromDate);
  const to = new Date();

  // Compute the remaining difference after adjusting for years and months
  let diffMs = to.getTime() - from.getTime();

  const MS_IN_SECOND = 1000;
  const MS_IN_MINUTE = MS_IN_SECOND * 60;
  const MS_IN_HOUR = MS_IN_MINUTE * 60;
  const MS_IN_DAY = MS_IN_HOUR * 24;
  const MS_IN_WEEK = MS_IN_DAY * 7;

  const weeks = Math.floor(diffMs / MS_IN_WEEK);
  diffMs %= MS_IN_WEEK;

  const days = Math.floor(diffMs / MS_IN_DAY);
  diffMs %= MS_IN_DAY;

  const hours = Math.floor(diffMs / MS_IN_HOUR);
  diffMs %= MS_IN_HOUR;

  const minutes = Math.floor(diffMs / MS_IN_MINUTE);
  diffMs %= MS_IN_MINUTE;

  const seconds = Math.floor(diffMs / MS_IN_SECOND);

  const timeParts: string[] = [];

  if (weeks > 0) timeParts.push(`${weeks} week${weeks > 1 ? "s" : ""}`);
  if (days > 0) timeParts.push(`${days} day${days > 1 ? "s" : ""}`);
  if (hours > 0) timeParts.push(`${hours} hour${hours > 1 ? "s" : ""}`);
  if (minutes > 0) timeParts.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);
  if (seconds > 0) timeParts.push(`${seconds} second${seconds > 1 ? "s" : ""}`);

  return timeParts.join(", ");
}
